import { render } from "./TopbarNotificationsBell.vue?vue&type=template&id=3696bfbe"
import script from "./TopbarNotificationsBell.vue?vue&type=script&lang=js"
export * from "./TopbarNotificationsBell.vue?vue&type=script&lang=js"

import "./TopbarNotificationsBell.vue?vue&type=style&index=0&id=3696bfbe&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__